import axios from 'axios'

const PiperunWrapper = {
  requestGet: (token, baseUrl, timeout = 0, nextPage) => {
    return new Promise((resolve, reject) => {
      let url = baseUrl
      let config = {
        headers: {
          token,
          'Content-Type': 'application/json'
        }
      }
      if (nextPage) {
        if (url.includes('?')) url += `&page=${nextPage}`
        else url += `?page=${nextPage}`
      }
      setTimeout(_ => {
        return axios.get(url, config).then(async ({ data }) => {
          const result = data.data
          const meta = data.meta
          const resultMapped = result.map(item => {
            return {
              id: item.id,
              account_id: item.account_id,
              name: item.name,
              email: item.email
            }
          })
          if (meta.current_page < meta.total_pages) {
            return PiperunWrapper.requestGet(token, baseUrl, 500, meta.current_page + 1)
              .then(response => {
                return resolve(resultMapped.concat(response))
              }).catch(reject)
          } else {
            return resolve(resultMapped)
          }
        }).catch(reject)
      }, timeout)
    })
  },
  getAllActivityTypes: (token) => {
    return new Promise((resolve, reject) => {
      return PiperunWrapper.requestGet(
        token,
        'https://api.moskitcrm.com/v2/activityTypes?quantity=50'
      ).then(activityTypes => {
        return resolve(activityTypes)
      }).catch(err => {
        return reject(err)
      })
    })
  },
  getUsers: (token) => {
    return new Promise((resolve, reject) => {
      return PiperunWrapper.requestGet(
        token,
        'https://api.pipe.run/v1/users?active=1'
      ).then(resolve).catch(reject)
    })
  }
}

export default PiperunWrapper



// WEBPACK FOOTER //
// ./src/services/piperun-wrapper.js